if (!customElements.get('featured-collection-slider')) {
  class FeaturedCollectionSlider extends HTMLElement {
    constructor() {
      super();
      this.sliderButtons = this.querySelectorAll('[data-slider-button]')
      this.slider = this.querySelector('slider-component ul');
      this.sliderCounter = this.querySelector('.slider-counter--current');
      this.pageTotalElement = this.querySelector('.slider-counter--total');
      this.sliderItemsToShow = [];
      this.currentPage = 1;

      if (!this.slider || !this.sliderButtons.length) return;

      this.initPages = this.initPages.bind(this);
      this.update = this.update.bind(this);
      this.onButtonClick = this.onButtonClick.bind(this);

      const metrics = this.initPages();
      if (metrics) {
        this.totalPages = metrics.totalPages;
        this.slidesPerPage = metrics.slidesPerPage;
        this.slideItemWidth = metrics.slideItemWidth;

        if (this.pageTotalElement) {
          this.pageTotalElement.textContent = this.totalPages;
        }
      }

      const resizeObserver = new ResizeObserver(() => {
        const newMetrics = this.initPages();
        if (newMetrics) {
          this.totalPages = newMetrics.totalPages;
          this.slidesPerPage = newMetrics.slidesPerPage;
          this.slideItemWidth = newMetrics.slideItemWidth;

          if (this.pageTotalElement) {
            this.pageTotalElement.textContent = this.totalPages;
          }
          this.update();
        }
      });
      resizeObserver.observe(this.slider);

      this.sliderButtons.forEach(button => {
        button.addEventListener('click', this.onButtonClick);
      });

      this.slider.addEventListener('scroll', this.update);
      this.update();
    }

    initPages() {
      this.sliderItemsToShow = Array.from(this.slider.querySelectorAll('[id^="Slide-"]'))
        .filter(element => {
          const style = window.getComputedStyle(element);
          return style.display !== 'none' && style.visibility !== 'hidden' && element.clientWidth > 0;
        });

      if (this.sliderItemsToShow.length < 1) return null;

      const containerWidth = this.slider.clientWidth;
      const isDesktop = window.innerWidth >= 750;
      const slideItemWidth = this.sliderItemsToShow[0].offsetWidth;
      const slidesPerPage = Math.floor(containerWidth / slideItemWidth) || 1;
      const totalPages = Math.ceil(this.sliderItemsToShow.length / slidesPerPage);

      return {
        slideItemWidth,
        slidesPerPage,
        totalPages,
        sliderItems: this.sliderItemsToShow
      };
    }

    update() {
      const previousPage = this.currentPage;
      const totalScrollWidth = this.slider.scrollWidth - this.slider.clientWidth;
      const scrollPercentage = totalScrollWidth === 0 ? 0 : this.slider.scrollLeft / totalScrollWidth;

      this.currentPage = Math.round(scrollPercentage * (this.totalPages - 1)) + 1;

      if (this.currentPage < 1) this.currentPage = 1;
      if (this.currentPage > this.totalPages) this.currentPage = this.totalPages;

      if (this.sliderCounter) {
        this.sliderCounter.textContent = this.currentPage;
      }

      this.sliderButtons.forEach(button => {
        if (button.name === 'previous') {
          button.disabled = this.currentPage === 1;
          button.setAttribute('aria-disabled', this.currentPage === 1);
        } else if (button.name === 'next') {
          button.disabled = this.currentPage === this.totalPages;
          button.setAttribute('aria-disabled', this.currentPage === this.totalPages);
        }
      });

      if (this.currentPage !== previousPage) {
        this.dispatchEvent(
          new CustomEvent('slideChanged', {
            detail: {
              currentPage: this.currentPage,
              currentElement: this.sliderItemsToShow[(this.currentPage - 1) * this.slidesPerPage]
            }
          })
        );
      }
    }

    onButtonClick(event) {
      event.preventDefault();
      const direction = event.currentTarget.name === 'next' ? 1 : -1;
      const currentScrollLeft = this.slider.scrollLeft;

      const newPosition = currentScrollLeft + (direction * this.slideItemWidth * this.slidesPerPage);

      this.slider.scrollTo({
        left: newPosition,
        behavior: 'smooth'
      });
    }

    isSlideVisible(element, offset = 0) {
      const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
      return element.offsetLeft + element.clientWidth <= lastVisibleSlide &&
        element.offsetLeft >= this.slider.scrollLeft;
    }
  }

  customElements.define('featured-collection-slider', FeaturedCollectionSlider);
}